module.exports = __webpack_public_path__ + "img/dayicon.073d1a15.svg";